import { Component, inject, ElementRef, HostListener } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { ScreenService } from '../../services/screen/screen.service';
import { PermissionsService } from '../../services/permissions/permissions.service';

import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TEXT_CONSTANTS } from '../../constants/text-constants';

interface MenuOption {
  label: string;
  icon: string;
  action?: () => void;
  route?: string;
}

@Component({
  selector: 'user-profile-menu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-profile-menu.component.html',
  styleUrl: './user-profile-menu.component.css'
})
export class UserProfileMenuComponent {
  private _authService = inject(AuthService);
  private _router = inject(Router);
  private _elementRef = inject(ElementRef);
  private _screenService = inject(ScreenService);
  private _permissionsService = inject(PermissionsService);

  currentUser: { name: string, avatar: string };
  dropdownOpen = false;

  menuOptions: MenuOption[] = [
    {
      label: TEXT_CONSTANTS.SIDEBAR.SETTINGS,
      icon: 'settings',
      route: '/settings'
    },
    {
      label: TEXT_CONSTANTS.AUTH.LOGOUT,
      icon: 'logout',
      action: () => this.logout()
    }
  ];

  constructor() {
    this.currentUser = {
      name: this._authService.getUserFullname(),
      avatar: ''
    };

    if (this._permissionsService.hasAccess('/admin')) {
      this.menuOptions.unshift({
        label: TEXT_CONSTANTS.SIDEBAR.ADMIN,
        icon: 'admin_panel_settings',
        route: '/admin'
      });
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this._elementRef.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
    }
  }

  toggleMenu() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  handleOptionClick(option: MenuOption) {
    this.dropdownOpen = false;
    if (option.action) {
      option.action();
    } else if (option.route) {
      this._router.navigateByUrl(option.route);
    }
  }

  private logout() {
    this._authService.logout();
    this._router.navigate(['/login']);
  }

  isMobileView(): boolean {
    return this._screenService.isMobile();

  }

  getCurrentUserInitial(): string {
    return this.currentUser.name.charAt(0).toUpperCase();
  }
}
